<template>
  <v-container class="mt-2 mr-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title >
            Unidades

            <v-spacer></v-spacer>
            
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( unidades  , 'unidades')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="8">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <!-- Tabla -->
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  dense
                  :search="search"
                >
                  
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      color="secondary"
                      small
                      class="mr-2"
                      @click="editItem(item)"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                    >
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.unidad"
                  filled
                  dense
                  label="Unidad"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  :items="['PIEZA','LONGITUD']"
                  v-model="editedItem.tipo"
                  filled
                  dense
                  label="Tipo"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  :items="[1,2,3]"
                  v-model="editedItem.lados"
                  filled
                  dense
                  label="Lados"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="editedItem.lados > 1">
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.factor1"
                  filled
                  dense
                  label="Factor 1"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="editedItem.lados == 2 || editedItem.lados == 3"
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.factor2"
                  filled
                  dense
                  label="Factor 2"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="editedItem.lados == 3"
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.factor3"
                  filled
                  dense
                  label="Factor 3"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            @click="close"
            tile
            dense
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            dark
            @click="save"
            tile
          >
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  export default {
    components:{
      Alerta,
      carga,
    },

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      headers: [
        { text: 'Unidad', align: 'start', sortable: false, value: 'unidad'},
        { text: 'Tipo',     value: 'tipo' },
        { text: 'Lados',    value: 'lados' },
        { text: 'Factor 1', value: 'factor1' },
        { text: 'Factor 2', value: 'factor2' },
        { text: 'Factor 3', value: 'factor3' },
        { text: 'Actions',  value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        idunidades:0,
        unidad: '',
        tipo: 'PIEZA',
        lados: 1,
        factor1:1.00,
        factor2:1.00,
        factor3:1.00
      },
      defaultItem: {
        idunidades:0,
        unidad: '',
        tipo: 'PIEZA',
        lados: 1,
        factor1:1.00,
        factor2:1.00,
        factor3:1.00
      },

      search:'',
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva unidad' : 'Editar unidad'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.desserts = []
        this.$http.get('unidades.all').then(response=>{
          this.desserts = response.body
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.cargar = true

        if (this.editedIndex > -1) {
          this.$http.put('unidades.update/' + this.editedItem.idunidades,this.editedItem).then(response=>{
            this.cargar = false
            this.close()
            this.initialize()          
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        } else {
          this.$http.post('unidades.add',this.editedItem).then(response=>{
            this.cargar = false
            this.close()
            this.initialize()          
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
      },
    },
  }
</script>